import {
  ADD,
  ADD_MULTIPLE,
  SET_TOTAL_VOLUNTEERS,
  SET_DISPLAYED_VOLUNTEER_IDS,
  UPDATE_VOLUNTEER_STATUS,
  UPDATE_VOLUNTEER_PROPERTY,
} from './constants';

export const addMultipleAction = (volunteers) => ({
  type: ADD_MULTIPLE,
  volunteers,
});

export const setTotalVolunteersAction = (total) => ({
  type: SET_TOTAL_VOLUNTEERS,
  total,
});

export const setDisplayedVolunteerIdsAction = (volunteerIds) => ({
  type: SET_DISPLAYED_VOLUNTEER_IDS,
  volunteerIds,
});

export const updateVolunteerStatusAction = (id, status) => ({
  type: UPDATE_VOLUNTEER_STATUS,
  id,
  status,
});

export const addAction = (volunteer) => ({
  type: ADD,
  volunteer,
});

export const updateVolunteerProperty = (id, property, value) => ({
  type: UPDATE_VOLUNTEER_PROPERTY,
  id,
  property,
  value,
});
